"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanels = exports.TabPanel = exports.TabList = exports.TabHeader = exports.Tab = exports.Tabs = void 0;

var tabs_1 = require("./tabs");

Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return tabs_1.Tabs;
  }
});

var tab_1 = require("./partials/tab");

Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return tab_1.Tab;
  }
});

var tab_header_1 = require("./styled/tab-header");

Object.defineProperty(exports, "TabHeader", {
  enumerable: true,
  get: function get() {
    return tab_header_1.TabHeader;
  }
});

var tab_list_1 = require("./partials/tab-list");

Object.defineProperty(exports, "TabList", {
  enumerable: true,
  get: function get() {
    return tab_list_1.TabList;
  }
});

var tabs_2 = require("@reach/tabs");

Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return tabs_2.TabPanel;
  }
});
Object.defineProperty(exports, "TabPanels", {
  enumerable: true,
  get: function get() {
    return tabs_2.TabPanels;
  }
});